const iframeVideoBackground = (HeadingComponentList) => {
    if (HeadingComponentList && HeadingComponentList.length > 0) {
        HeadingComponentList.forEach((HeadingComponent) => {
            const backgroundVideo = HeadingComponent.querySelector("[data-background-video]");
            const iframeVideo = HeadingComponent.querySelector("[data-iframe-video]");
            if (backgroundVideo) {
                const backgroundVideoDesktop = backgroundVideo.getAttribute("data-video-desktop");
                const backgroundVideoMobile = backgroundVideo.getAttribute("data-video-mobile");
                if (backgroundVideoDesktop && backgroundVideoMobile) {
                    if (window.innerWidth >= 768) {
                        iframeVideo.setAttribute("src", `${backgroundVideoDesktop}&autoplay=1&loop=1&controls=0&mute=1&background=1`);
                    }
                    else {
                        iframeVideo.setAttribute("src", `${backgroundVideoMobile}&autoplay=1&loop=1&controls=0&mute=1&background=1`);
                    }
                    iframeVideo.setAttribute("title", "video");
                }
            }
        });
    }
};
